module.exports = __webpack_public_path__ + "img/logo.277d37cc.png";